import React from 'react';
import { motion } from 'framer-motion';
import './PolicyPage.css';

const RefundCancellationPolicy = () => {
  return (
    <section className="policy-page section">
      <div className="container">
        <motion.div 
          className="policy-content"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1>💳 Refund & Cancellation Policy</h1>
          <p className="last-updated">Last updated: June 11, 2025</p>
          
          <p>This policy applies to any services or paid features provided by Digital Fig, operated by Ctrl Digital Tech Ltd.</p>
          
          <p>Information regarding refunds and cancellations will be outlined in the specific terms and conditions provided with any contracted work or service agreement.</p>

          <h2>Refunds</h2>
          <p>We may offer partial or full refunds under the following circumstances:</p>
          <ul>
            <li>Technical errors on our part that prevent delivery of services</li>
            <li>Project cancellations initiated by us</li>
          </ul>
          
          <p>Refunds are not issued for:</p>
          <ul>
            <li>Completed services or digital products delivered as set out in the contracted Terms and Conditions.</li>
            <li>Customer change of mind after delivery of service.</li>
          </ul>
          
          <p>All refund requests must be submitted in writing to <a href="mailto:hello@digitalfig.com">hello@digitalfig.com</a></p>

          <h2>Cancellations</h2>
          <ul>
            <li>If you wish to cancel a project or service, please notify us at <a href="mailto:hello@digitalfig.com">hello@digitalfig.com</a></li>
            <li>Depending on the stage of delivery, partial charges may apply</li>
          </ul>
          
          <p>If you have any questions about our refund or cancellation process, please email us at <a href="mailto:hello@digitalfig.com">hello@digitalfig.com</a> and we'll be happy to assist you.</p>
        </motion.div>
      </div>
    </section>
  );
};

export default RefundCancellationPolicy;